import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Asset, Header } from '@aptsi-types';
import { ZoneService } from '../zone.service';

@Component({
  selector: 'app-zone-assets',
  templateUrl: './zone-assets.component.html',
  styleUrls: ['./zone-assets.component.scss']
})
export class ZoneAssetsComponent {
      constructor(
        public dialogRef: MatDialogRef<ZoneAssetsComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { zoneId: string; zoneName: string }, private zoneService: ZoneService
       
      ) {}

      filteredAssets: Asset[] = [];

      headers: Header[] = [
        {name: 'Asset ID', property: 'assetId', showInDropdown: true, description: 'Unique identifier for the asset'},
        { name: 'Asset Name', property: 'assetName', showInDropdown: true, description: 'Name of the asset' },
        { name: 'Description', property: 'description', showInDropdown: true, description: 'Description of the asset' },
        { name: 'Business Value', property: 'businessValue', showInDropdown: true, description: 'Business value of the asset' },
        { name: 'Data Classification', property: 'dataClassification', showInDropdown: true, description: 'Data classification of the asset' }
      ];


      ngOnInit(): void { 
          this.fetchAssetsForZone(this.data.zoneId);
      }


      fetchAssetsForZone(zoneId: string): void {
        this.zoneService.getZoneAssetsByZoneId(zoneId).subscribe(
          (assets: Asset[]) => {
            this.filteredAssets = assets;
          },
          (error) => {
            console.error('Error fetching assets for zone:', error);
          }
        );
       
      }

      
      back(): void {
        this.dialogRef.close();
      }

}